import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { isNullOrEmpty, showMessageToast, translate } from '../../../utils/util';
import { Input } from '../../../components/UI/ComponentsUI';
import { ENUMS } from '../../../utils/constants';

const SearchMVIList = (props) => {
  const calcBoxItems = () => {
    var resto = (props.item.transmission?.boxQuantityItems / props.item.transmission.quantityLocation) % 1 !== 0;
    var qtdCaixas = props.item.transmission?.boxQuantityItems / props.item.transmission.quantityLocation + (resto ? 1 : 0);
    return Math.round(qtdCaixas);
  }

  const validStatus = (item, message) => {
    if (item.status === ENUMS.eReceiptStatus.Anomaly.value || item.status === ENUMS.eReceiptStatus.Wait.value) {
      if (message) {
        showMessageToast({ html: "Pendencia Contábil, procurar time SHARED SERVICES", classes: 'red' });
      }
      return false;
    }

    return true;
  }

  return (
    <>
      <div className="input-field no-padding col s2" style={{ position: 'absolute', marginTop: '10px', right: '5px', zIndex: '999' }}>
        <Input
          id={`${props.index}.mdrNew`}
          name={`${props.index}.mdrNew`}
          label="MDR"
          type="text"
          onChange={props.onChange}
          defaultValue={props.item?.mdr}
        />
      </div>
      <div className="input-field no-padding col s2" style={{ position: 'absolute', marginTop: '80px', right: '5px', zIndex: '999' }}>
        <Input
          id={`${props.index}.qmeQuantity`}
          name={`${props.index}.qmeQuantity`}
          label="QME"
          type="number"
          onChange={props.onChange}
          disabled={props.item.checked}
          defaultValue=""
        />
      </div>

      <span
        className="title sixth-text-color right"
        style={{ position: 'absolute', marginTop: '130px', right: '40px', zIndex: '999', cursor: 'pointer' }}
      >
        < i onClick={() => {
          props.sendLocationItem(props.item)
        }} className={`mdi mdi-36px mdi-file-replace text`} />
      </span>
      {!isNullOrEmpty(props.item.masterCim) &&
        <span
          className="title sixth-text-color right"
          style={{ position: 'absolute', marginTop: '180px', right: '15px', zIndex: '999', cursor: 'pointer' }}
        >
          <Input
            type="checkbox"
            onChange={() => props.onCheckItem(props.item)}
            id="select"
            name="select"
            label="Master CIM"
            checked={props.item.checked}
          />
        </span>
      }
      {

        // props.item.balance > 0 &&
        <span
          className="title sixth-text-color right"
          style={{ position: 'absolute', marginTop: '130px', right: '5px', zIndex: '999', cursor: 'pointer' }}
        >
          < i onClick={() => {
            if (validStatus(props.item, true)) {
              props.createConfirmation(props.item, props.item.mdr);


            }
          }}
            className={`mdi mdi-36px mdi-arrow-down green-text`} />
        </span>
      }
      <div
        id={props.item.id}
        style={{ backgroundColor: 'white', color: 'black', display: 'block', padding: '18px' }}
      >
        <div className="row" style={{ marginBottom: '0px' }}>
          <div className="title black-text col s12" style={{ padding: '0px', paddingLeft: '0px' }}>
            {props.item.receipt.partNumberCode}
          </div>
          <div className="title black-text col s12" style={{ padding: '0px', paddingLeft: '0px' }}>
            CIM: {props.item.cim}
          </div>
        </div>
        <div className="row" style={{ marginBottom: '0px' }}>
          {
            !isNullOrEmpty(props.item.masterCim) &&
            <div className="col s12" style={{ padding: '0px' }}>Master CIM: {props.item.masterCim}</div>
          }
          {
            !isNullOrEmpty(props.item.cimPallet) &&
            <div className="col s12" style={{ padding: '0px' }}>CIM Pallet: {props.item.cimPallet}</div>
          }
          <div className="col s12" style={{ padding: '0px' }}>
            <small>{props.item.partNumberDescription}</small>
          </div>
          <div className="col s12" style={{ padding: '0px' }}>
            <small>{`${translate('truck-kanban:mvm')}: ${props.item.receipt.mvmNumber} / ${translate('physical-confirmation:journey')}: ${props.item.receipt.journey}`}</small>
          </div>
          <div className="col s5" style={{ padding: '0px' }}>
            <small>{`${translate('physical-confirmation:shed')}: ${props.item.receipt.shed}`}</small>
          </div>
          <div className="col s5" style={{ padding: '0px' }}>
            <small>{`${translate('truck-kanban:invoice-number')}: ${props.item.receipt.invoice}`}</small>
          </div>
          <div className="col s5" style={{ padding: '0px' }}>
            <small>{`${translate('truck-kanban:amount-received')}: ${(props.item.quantity || 0)} `}</small>
          </div>
          <div className="col s5" style={{ padding: '0px' }}>
            <small>{`QME Caixa: ${(props.item.cimQuantity)} `}</small>
          </div>
          <div className="col s5" style={{ padding: '0px' }}>
            <small>{`Qtd. Caixas: ${calcBoxItems()} `}</small>
          </div>
          <div className="col s5" style={{ padding: '0px' }}>
            <small>{`Almox: ${(props.item.receipt.almox)} `}</small>
          </div>
          <div className="col s5" style={{ padding: '0px' }}>
            <small>{`Pallet: ${(props.item.idPallet)} `}</small>
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = () => {
  return {

  };
};

const mapDispatchToProps = () => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SearchMVIList));
